import styled from 'styled-components';

import Text from 'shared/components/Text/Text';

export const ConfirmBillingAddressContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 488px;
  align-items: center;
  margin-top: 24px;
`;

export const Title = styled(Text)<{ $addressConfirmed: boolean }>`
  font-weight: 500;
  color: ${({ theme }) => theme.colors.textPrimarySecondary1100};
  text-align: center;
  margin: 20px 0;

  @media (min-width: ${({ theme }) => theme.breakpoints.small}) {
    margin: ${({ $addressConfirmed }) => ($addressConfirmed ? '24px 0' : '40px 0 24px')};
  }
`;

export const BodyTextContainer = styled.div``;

export const BodyText = styled(Text)`
  font-weight: 400;
  color: ${({ theme }) => theme.colors.textSecondaryGrey90};
`;

export const AddressContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;
  margin: 20px 0;
  padding: 24px 32px;
  border-radius: 20px;
  border: 1px solid ${({ theme }) => theme.colors.strokePrimaryGrey20};

  @media (min-width: ${({ theme }) => theme.breakpoints.small}) {
    margin: 32px 0 65px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.medium}) {
    margin: 32px 0;
  }
`;

export const AddressText = styled(BodyText)`
  font-weight: 800;
`;

export const ActionContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  gap: 12px;
  max-width: 292px;

  @media (min-width: ${({ theme }) => theme.breakpoints.medium}) {
    max-width: 256px;
  }
`;
